/**
 * IDs de medição por loja — `tenant.theme_json.storeAnalytics`.
 */

/** @param {unknown} themeJson */
export function normalizeThemeJson(themeJson) {
  let obj = themeJson;
  if (typeof obj === 'string') {
    try {
      obj = JSON.parse(obj);
    } catch {
      return {};
    }
  }
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return {};
  return /** @type {Record<string, unknown>} */ (obj);
}

/** @param {unknown} raw */
function normalizeGa4Id(raw) {
  const s = typeof raw === 'string' ? raw.trim().toUpperCase() : '';
  if (!s) return '';
  return /^G-[A-Z0-9]+$/.test(s) ? s : '';
}

/** @param {unknown} raw */
function normalizePixelId(raw) {
  const s = typeof raw === 'string' ? raw.trim() : String(raw ?? '').trim();
  if (!s || !/^\d+$/.test(s)) return '';
  return s;
}

/**
 * @param {unknown} themeJson
 * @returns {{ ga4MeasurementId: string, metaPixelId: string, hasTracking: boolean }}
 */
export function parseStoreAnalytics(themeJson) {
  const base = normalizeThemeJson(themeJson);
  const raw = base.storeAnalytics;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return { ga4MeasurementId: '', metaPixelId: '', hasTracking: false };
  }
  const ga4MeasurementId = normalizeGa4Id(raw.ga4MeasurementId);
  const metaPixelId = normalizePixelId(raw.metaPixelId);
  return {
    ga4MeasurementId,
    metaPixelId,
    hasTracking: Boolean(ga4MeasurementId || metaPixelId),
  };
}

/** @param {unknown} themeJson */
export function storeAnalyticsBodyForEditor(themeJson) {
  const parsed = parseStoreAnalytics(themeJson);
  return {
    ga4MeasurementId: parsed.ga4MeasurementId,
    metaPixelId: parsed.metaPixelId,
  };
}
